import { get, isString, omit, isEmpty, toLower } from "lodash";
import { getUserId } from "src/utils";
import { Auth } from "aws-amplify";

export const setCreateTargetVariable = (
  data,
  status,
  targetId,
  formatCreateTargetVariables
) => {
  return {
    input: formatCreateTargetVariables(data, status, targetId),
  };
};

export const setAutoSaveCreateTargetVariable = (
  data,
  status,
  targetId,
  formatCreateTargetVariables
) => {
  return {
    ...formatCreateTargetVariables(data, status, targetId),
    isAutoSavedBeforeSubmit: true,
  };
};

export const setAddObjectiveVariable = (data, targetId) => {
  const { updatedObjList, deletedObjList } = data;
  const assignObjectivesToTarget = {
    targetObjectives: [...(updatedObjList || []), ...deletedObjList].map(
      (o, i) => {
        let _obj = {
          completionRequired: o.completionRequired,
          isDeleted: o.isDeleted,
          objectiveStatusTrack: o.objectiveStatusTrack || false,
          name: o.name,
          autoEnroll: o.autoEnroll,
          objectiveSequenceNo: i + 1,
          users: {
            individualUsers: get(o, "assignPeople.userListData", [])
              .filter(({ selected }) => selected)
              .map((u) => {
                return {
                  isSelected: true,
                  userid: u.id,
                };
              }),
            groupUsers: get(o, "users.userGroupData", [])
              .filter(
                (item) =>
                  item.__typename === "GroupUsers" &&
                  item.isSelectedForObjective
              )
              .map((ug) => {
                return {
                  groupId: ug.groupId,
                  users: get(ug, "users", []).map((u) => {
                    return {
                      userid: u.id,
                    };
                  }),
                };
              }),
            departmentUsers: get(o, "users.userGroupData", [])
              .filter(
                (item) =>
                  item.__typename === "DepartmentUsers" &&
                  item.isSelectedForObjective
              )
              .map((ud) => {
                return {
                  department: ud.department,
                  users: get(ud, "users", []).map((u) => {
                    return {
                      userid: u.id,
                    };
                  }),
                };
              }),
          },
        };
        if (o.id) {
          _obj.id = o.id;
        }
        return _obj;
      }
    ),
  };
  // const assignObjectivesToTarget = {
  //   targetObjectives: [
  //     {
  //       isDeleted: false,
  //       name: data.name,
  //       autoEnroll: data.autoEnroll,
  //       objectiveSequenceNo: 0,
  //       objectiveStatusTrack: data?.objectiveStatusTrack || false,
  //       users: {
  //         individualUsers: data.people.map((user) => {
  //           return {
  //             userid: user.id,
  //             isSelected: user.isSelectedForObjective || user.selected,
  //           };
  //         }),
  //         groupUsers: [],
  //         departmentUsers: [],
  //       },
  //     },
  //   ],
  // };

  return {
    input: {
      id: targetId,
      targetCompanyId: get(Auth, "user.attributes.custom:companyId", ""),
      createdByUserId: getUserId(),
      assignObjectivesToTarget,
      currentAction: "AddObjective",
    },
  };
};

export const setAddSkillsAndStrengthsVariable = (data, targetId) => {
  const skillsAndStrengths = (data || []).map((item) => {
    const data = {
      category: item.category,
      color: item.color,
      isStrength: item.isStrength,
      name: item.name,
      description: item.description,
    };
    if (item?.id) {
      data.id = item?.id;
    }
    return data;
  });

  return {
    input: {
      id: targetId,
      targetCompanyId: get(Auth, "user.attributes.custom:companyId", ""),
      createdByUserId: getUserId(),
      skillsAndStrengths,
      currentAction: "AddSkillsAndStrengths",
    },
  };
};

export const setAddAttachmentVariable = (data, targetId, attachment) => {
  let targetAttachmentLinks = [];
  let document = [];
  if (attachment) {
    if (!isString(attachment)) {
      document.push(omit(attachment, ["name", "type", "__typename"]));
    } else {
      targetAttachmentLinks.push(attachment);
    }
  } else {
    document = data.advancedOptions.attachments.map((item) => {
      if (!isString(item) && item.name) {
        return omit(item, ["name", "type", "__typename"]);
      } else {
        targetAttachmentLinks.push(item);
        return false;
      }
    });
  }
  const attachments = {
    document: document.filter(Boolean),
    targetAttachmentLinks,
  };
  return {
    input: {
      ...attachments,
      id: targetId,
      targetCompanyId: get(Auth, "user.attributes.custom:companyId", ""),
      createdByUserId: getUserId(),
      currentAction: attachment
        ? "RemoveTargetAttachment"
        : "AddTargetAttachment",
    },
  };
};

export const setTargetSelfRatingVariable = (rating, comment, targetId) => {
  const variable = {
    input: {
      approvalCurrentAction: "CoacheeCompletionRequest",
      processStatus: "COMPLETED",
      // rating,
      comment,
      targetId,
      userId: getUserId(),
    },
  };
  if (rating) {
    variable.input.rating = rating;
  }
  return variable;
};

export const setMarkCompleteUsersVariable = (userListToRate, targetId) => {
  return {
    input: {
      targetId,
      isTargetCompletion: true,
      userListToRate,
    },
  };
};

export const setTargetUserRateVariable = (
  userListToRate,
  userRole,
  isSubmit,
  targetId
) => {
  const users = userListToRate.map((user) => {
    let usersToRate = {
      id: get(user, `userTargetId`),
      comment: get(user, `comment`),
      currentUserTargetStatus: ["pending"].includes(
        toLower(get(user, "status"))
      )
        ? "PENDINGAPPROVAL"
        : get(user, "status"),
    };
    if (user?.rating) {
      usersToRate.rating = get(user, `rating`);
    }
    return usersToRate;
  });

  return {
    input: {
      targetId,
      completionRequestUserRole: userRole,
      isSubmit,
      userListToRate: users,
    },
  };
};

export const setSurveyRespondCheckinVariable = (
  data,
  targetId,
  type = "SURVEY",
  viewDetails = {}
) => {
  const {
    surveyCheckin,
    checkinId,
    isanonymous,
    score,
    frequency,
    usercomment,
    details,
  } = data;
  const variable = {
    input: {
      id: checkinId,
      userCheckin: {
        id: get(frequency, "id"),
        checkinid: checkinId,
        checkinSequenceNo: get(frequency, "checkinSequenceNo"),
        checkInStatus: "COMPLETE",
        checkInEndDate: get(frequency, "checkInEndDate"),
        checkInStartDate: get(frequency, "checkInStartDate"),
        userid: getUserId(),
      },
      checkInTargetId: targetId,
    },
  };

  if (type === "SURVEY") {
    variable.input.userCheckin.surveyCheckin = {
      isanonymous,
      score,
      surveycheckin: surveyCheckin,
    };
  } else if (type === "LEARNING") {
    let responseDocument = { ...get(details, "multimedia.attachments.0", "") };
    if (responseDocument) {
      responseDocument = omit(responseDocument, ["name", "type"]);
      variable.input.userCheckin.usercomment = usercomment;
      if (typeof details?.multimedia?.attachments?.[0] === "string")
        variable.input.userCheckin.attachmentLink = {
          link: details?.multimedia?.attachments?.[0],
        };
      else
        variable.input.userCheckin.responseDocument = {
          ...responseDocument,
        };
    }
  } else if (type === "REQUESTFEEDBACK") {
    const updatedAttachmentData = details?.multimedia?.attachments?.filter(
      (y) => y !== undefined && y !== null
    );
    let surveyLinks = (updatedAttachmentData || [])
      .filter((item) => isString(item))
      .map((res) => {
        let details = {
          ...(!isEmpty(data?.viewLink) ? data?.viewLink : viewDetails),
        };
        details = omit(details, ["url", "__typename"]);
        if (!details?.image) {
          delete details.image;
        }
        return {
          link: res,
          ...details,
        };
      });
    const multimediaCheckin = (
      (!isString(data?.details?.multimedia?.attachments) &&
        updatedAttachmentData) ||
      []
    )
      .filter((item) => !isString(item))
      .map((item) => {
        return omit(item, ["name", "type", "__typename"]);
        // const data = omit(item, ["name", "type", "__typename"]);
        // return data;
      });

    if (!isEmpty(surveyLinks)) {
      variable.input.userCheckin.attachmentLink = surveyLinks;
    }

    if (!isEmpty(multimediaCheckin)) {
      variable.input.userCheckin.requestFeedbackAttachments =
        multimediaCheckin.map((res) => ({
          s3Link: res,
        }));
    }

    // let responseDocument = { ...get(details, "multimedia.attachments.0", "") };
    // if (responseDocument) {
    //   responseDocument = omit(responseDocument, ["name", "type"]);
    //   variable.input.userCheckin.usercomment = usercomment;
    //   // if (typeof updatedAttachmentData?.[0] === "string") {
    //   //   // variable.input.userCheckin.attachmentLink = {
    //   //   //   link: updatedAttachmentData?.[0],
    //   //   // };
    //   //   variable.input.userCheckin.attachmentLink = surveyLinks;
    //   // } else {
    //   //   variable.input.userCheckin.responseDocument = {
    //   //     ...responseDocument,
    //   //   };
    //   // }
    //   variable.input.userCheckin.responseDocument = {
    //     ...responseDocument,
    //   };
    // }
    variable.input.userCheckin.usercomment = usercomment;
    variable.input.userCheckin.surveyCheckin = {
      isanonymous,
      score,
      surveycheckin: surveyCheckin,
    };
  }
  return variable;
};
